export default {
  mounted () {
    window.onscroll = (ev) => {
      const bArrow = document.getElementById('bottomArrow')

      if (!bArrow) {
        return
      }

      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        bArrow.classList.remove('icon-rotate-down')
        bArrow.classList.add('icon-rotate-up')
      } else {
        bArrow.classList.remove('icon-rotate-up')
        bArrow.classList.add('icon-rotate-down')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/bottomArrow.js